// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6f8ab1ab","732":"486a7378","977":"8318cc92"}[chunkId] + ".chunk.js";
};